import { render } from "./select.vue?vue&type=template&id=5269f081&scoped=true"
import script from "./select.vue?vue&type=script&lang=js"
export * from "./select.vue?vue&type=script&lang=js"

import "./select.vue?vue&type=style&index=0&id=5269f081&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1943814799/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5269f081"]])

export default __exports__